(function () {
    if (!window.location.pathname.match(/\/user\/bookings\/.+/g)) return;

    $('.cancel-booking').on('click', function (e) {
        e.preventDefault();

        $(this).parent('form').submit();
    });

    $('.cancel-booking-modal-submit').on('click', function (e) {
        e.preventDefault();

        $('#cancel-booking-modal').modal('hide');
        $('.cancel-booking-form').submit();
    });
})();
